import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useVideos(data = {}) {
  const { enabled = false, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getVideos() {
    return privateFetch.get(`/v1/admin/topic/all/video`, configs).then((res) => res.data);
  }

  return useQuery('topics-videos-list', getVideos, { enabled });
}

export default useVideos;
